import { render, staticRenderFns } from "./QuestionGroupCreate.vue?vue&type=template&id=f7414874&scoped=true&"
import script from "./QuestionGroupCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionGroupCreate.vue?vue&type=style&index=0&id=f7414874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7414874",
  null
  
)

export default component.exports